/** NOT FULLY SUPPORTED BY SAFARI therefore ->
 * window.requestIdleCallback()
 * version 0.0.0
 * Browser Compatibility:
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback#browser_compatibility
 */

if (!window.requestIdleCallback) {
  window.requestIdleCallback = function (callback, options) {
    const opts = options || {};
    const relaxation = 1;
    const timeout = opts.timeout || 0;
    const start = performance.now();
    return setTimeout(function () {
      callback({
        get didTimeout() {
          return timeout > 0 && performance.now() - start >= timeout;
        },
        timeRemaining: function () {
          const elapsed = performance.now() - start;
          return Math.max(0, relaxation - elapsed);
        }
      });
    }, relaxation);
  };
}

/**
 * Loads a Vite script on idle.
 * @param {string} scriptKey - The key in the viteManifest object.
 * @param {Object} observer - The observer instance which needs to be killed.
 * @param {integer} timeout - The time to wait before loading in ms.
 */
const loadViteScriptOnIdle = (scriptKey, timeout) => {
  if (import.meta.env.MODE === 'development') {
    // Development mode: dynamic imports with HMR
    if (!document.querySelector(`script[data-vite-script="${scriptKey}"]`)) {
      const loadScript = () => {
        const modules = import.meta.glob('../../*.{js,ts}');
        const jsPath = `../../${scriptKey}.js`;
        const tsPath = `../../${scriptKey}.ts`;
        const loader = modules[jsPath] || modules[tsPath];

        if (loader) {
          loader()
            .then(module => {
              console.log(`${scriptKey} module loaded`, module);
            })
            .catch(err => {
              console.error(`Failed to load module: ${scriptKey}`, err);
            });
        } else {
          console.warn(`No module found for ${scriptKey} (looked for ${jsPath} and ${tsPath})`);
        }
      };
      setTimeout(loadScript, timeout || 0);
    }
  } else {
    // Production mode: load scripts using the manifest and the window-stored manifest-attributes
    const scriptUrl = window.viteManifest[scriptKey];
    if (scriptUrl && !document.querySelector(`script[src="${scriptUrl}"]`)) {
      const scriptTag = document.createElement('script');
      scriptTag.src = scriptUrl;
      scriptTag.type = 'module';
      scriptTag.async = true;
      document.head.appendChild(scriptTag);
    }
  }
};

let target;

//Chat Bundle Loading on Interaction and Idle

/** Adding these lines to the header on IDLE
 * <script type="module" src="/assets/dist/support-chat/otto-support-chat.esm.js" nonce="CSP_NONCE_PLACEHOLDER"></script>
 * <script nomodule="" src="/assets/dist/support-chat/otto-support-chat.js" nonce="CSP_NONCE_PLACEHOLDER"></script>
 */
const chatLoader = timeout => {
  requestIdleCallback(
    () => {
      setTimeout(() => {
        if (document.querySelector('otto-support-chat') && !(window.location.search.indexOf('mobile=1') > 0 || onAppCall)) {
          //MODULE SCRIPT TAG
          const scriptTag = document.createElement('script'); // Create a new script tag
          scriptTag.type = 'module'; // Set the type of the script
          scriptTag.src = '/assets/dist/support-chat/otto-support-chat.esm.js'; // Set the source of the script
          // Add the nonce attribute if available
          const noncedTag = document.querySelector('[nonce]');
          if (noncedTag && noncedTag.nonce) {
            scriptTag.nonce = noncedTag.nonce;
          }
          document.head.appendChild(scriptTag); // Append the script tag to the head
          //NOMUDULE SCRIPT
          const nomoduleTag = document.createElement('script'); // Create a new script tag
          nomoduleTag.nomodule = true; // Set the type of the script
          nomoduleTag.src = '/assets/dist/support-chat/otto-support-chat.js'; // Set the source of the script
          /* Add the nonce attribute if available
          if (noncedTag && noncedTag.nonce) {
            nomoduleTag.nonce = noncedTag.nonce;
          }*/
          document.head.appendChild(nomoduleTag); // Append the script tag to the head
        }
      }, timeout || 300);
    },
    { timeout: 100 }
  );
};

// Tooltip Observer
target = document.querySelectorAll('[data-tooltip]'); // Get the elements to observe
if (target.length) {
  //Load on idle
  requestIdleCallback(
    () => {
      loadViteScriptOnIdle('tooltip', 2400);
    },
    { timeout: 1300 }
  );
}

// Rive Observer
target = document.querySelectorAll('.app-cases-block'); // Get the elements to observe
if (target.length) {
  //Load on idle
  requestIdleCallback(
    () => {
      loadViteScriptOnIdle('rive', 1200);
    },
    { timeout: 1000 }
  );
}

// User Interaction Events
const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart']; // The events to listen for

/**
 * Load the interaction script when the user interacts with the page.
 */
const loadInteractionScript = () => {
  activityEvents.forEach(event => document.removeEventListener(event, loadInteractionScript)); // Remove the event listeners
  setTimeout(() => {
    loadViteScriptOnIdle('interaction', 200);
  }, 200); // Wait for a short time before loading the script
  chatLoader(600); //load chat on idle after 600ms
};

// Add event listeners for user interaction events
activityEvents.forEach(event => document.addEventListener(event, loadInteractionScript));
